import React from "react";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddBoxIcon from "@mui/icons-material/AddBox";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink, useLocation } from "react-router-dom";
import { CSSProperties } from "react";

interface SidebarProps {
  drawerWidth: number;
  mobileOpen: boolean;
  handleDrawerTransitionEnd: () => void;
  handleDrawerClose: () => void;
  handleDrawerToggle: () => void;
  pcSidebarVisible: boolean;
}

interface MenuItem {
  text: string;
  path: string;
  icon: React.ComponentType;
}

const baseLinkStyle: CSSProperties = {
  textDecoration: "none",
  color: "inherit",
  display: "block",
};

const activeLinkStyle: CSSProperties = {
  backgroundColor: "rgba(0, 0, 0, 0.08)",
};

const Sidebar: React.FC<SidebarProps> = ({
  drawerWidth,
  mobileOpen,
  handleDrawerTransitionEnd,
  handleDrawerClose,
  handleDrawerToggle,
  pcSidebarVisible,
}) => {
  const location = useLocation();

  const menuItems: MenuItem[] = [
    { text: "ダッシュボード", path: "/dashboard", icon: DashboardIcon },
    { text: "ARグッズ登録", path: "/ar-goods-register", icon: AddBoxIcon },
    //{ text: "ユーザー情報", path: "/user-info", icon: AddBoxIcon },
  ];

  const drawer = (
    <div>
      <List>
        {/* サイドバー上部のメニューアイコン */}
        <ListItem disablePadding>
          <ListItemButton onClick={handleDrawerToggle}>
            <ListItemIcon>
              <MenuIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <NavLink
            key={item.text}
            to={item.path}
            style={{
              ...baseLinkStyle,
              ...(location.pathname === item.path ? activeLinkStyle : {}),
            }}
            onClick={handleDrawerClose} // リンクをクリックしたらサイドバーを閉じる
          >
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <item.icon />
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          </NavLink>
        ))}
      </List>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: pcSidebarVisible ? drawerWidth : 0 }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      {/* モバイル用ドロワー */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* PC用ドロワー */}
      <Drawer
        variant="persistent"
        open={pcSidebarVisible}
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
